import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";

import { initFirebaseBackend, firebaseConfig } from "./helpers/firebase_helper";

// Initialize Firebase app
const firebaseApp = initializeApp(firebaseConfig);

// Get Firebase services
const projectStorage = getStorage(firebaseApp);
const projectFirestore = getFirestore(firebaseApp);
const projectFunctions = getFunctions(firebaseApp);
const auth = getAuth(firebaseApp);

// Retrieve stored authentication user data
const obj = JSON.parse(localStorage.getItem("authUser"));

export { projectFirestore, projectStorage, obj, projectFunctions, auth };
